import jQuery from 'jquery';

export const initPrice = () => {
	jQuery(() => {
		let $selected = jQuery('#js-price :selected').val();
		jQuery($selected).fadeIn().siblings('div').hide();
		jQuery('#js-price').change(() => {
			$selected = jQuery('#js-price :selected').val();
			jQuery($selected).fadeIn('fast').siblings().hide();
		});
	});
};
